document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCarrusel();
  initGaleriaProducto();
  initVariantesProducto();
  initContador();
  initAddToCart();
  initSwatches();
  initStickyBar();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initCarrusel() {
  document.querySelectorAll('[data-mt-carrusel]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-mt-track]');
    var prev = wrap.querySelector('[data-mt-prev]');
    var next = wrap.querySelector('[data-mt-next]');
    if (!track) return;
    var step = function () {
      var card = track.querySelector('[data-mt-card]');
      return card ? card.getBoundingClientRect().width + 20 : 300;
    };
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  });
}

function initContador() {
  document.querySelectorAll('[data-mt-contador]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
    var suffix = el.getAttribute('data-mt-sufijo') || '';
    var done = false;
    if (!('IntersectionObserver' in window)) {
      el.textContent = target + suffix;
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !done) {
          done = true;
          var start = null;
          var duration = 1400;
          function tick(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var val = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
            el.textContent = val + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(el);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var main = galeria.querySelector('[data-mt-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-mt-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activo'); });
        thumb.classList.add('mt-thumb-activo');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
    var dataEl = root.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = root.querySelectorAll('[data-mt-opcion]');
    var idInput = root.querySelector('[data-mt-variant-id]');
    var precioEl = root.querySelector('[data-mt-precio]');
    var precioCompareEl = root.querySelector('[data-mt-precio-comparado]');
    var addBtn = root.querySelector('[data-mt-add]');
    var addBtnTexto = addBtn ? addBtn.getAttribute('data-texto-normal') : '';
    var addBtnAgotado = addBtn ? addBtn.getAttribute('data-texto-agotado') : '';

    function moneda(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var seleccion = [];
      selects.forEach(function (sel) { seleccion.push(sel.value); });
      var match = variantes.find(function (v) {
        return v.options.length === seleccion.length && v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (precioEl) precioEl.textContent = moneda(match.price);
      if (precioCompareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          precioCompareEl.textContent = moneda(match.compare_at_price);
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        var addBtnSpan = addBtn.querySelector('span');
        if (match.available) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');
          if (addBtnSpan) { addBtnSpan.textContent = addBtnTexto || addBtnSpan.textContent; }
          else { addBtn.textContent = addBtnTexto || addBtn.textContent; }
        } else {
          addBtn.disabled = true;
          if (addBtnSpan) { addBtnSpan.textContent = addBtnAgotado || 'Agotado'; }
          else { addBtn.textContent = addBtnAgotado || 'Agotado'; }
        }
      }
    }

    selects.forEach(function (sel) { sel.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initSwatches() {
  document.querySelectorAll('[data-mt-swatches]').forEach(function (wrap) {
    var select = wrap.nextElementSibling;
    if (!select || select.tagName !== 'SELECT') return;
    var label = wrap.parentElement.querySelector('[data-mt-opcion-valor]');
    wrap.querySelectorAll('[data-mt-swatch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var valor = btn.getAttribute('data-valor');
        select.value = valor;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        wrap.querySelectorAll('[data-mt-swatch]').forEach(function (b) { b.classList.remove('mt-swatch-activo'); });
        btn.classList.add('mt-swatch-activo');
        if (label) label.textContent = valor;
      });
    });
  });
}

function initStickyBar() {
  var bar = document.querySelector('[data-mt-sticky]');
  var formWrap = document.querySelector('[data-mt-add-form-wrap]');
  if (!bar || !formWrap) return;

  var addBtn = formWrap.querySelector('[data-mt-add]');
  var stickyBtn = bar.querySelector('[data-mt-sticky-add]');
  if (stickyBtn && addBtn) {
    stickyBtn.addEventListener('click', function () { addBtn.click(); });
  }

  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('mt-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    obs.observe(formWrap);
  }

  var stickyPrecio = bar.querySelector('[data-mt-sticky-precio]');
  var precioReal = document.querySelector('[data-mt-precio]');
  if (stickyPrecio && precioReal && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () { stickyPrecio.textContent = precioReal.textContent; });
    mo.observe(precioReal, { childList: true, characterData: true, subtree: true });
  }
}

function initAddToCart() {
  document.querySelectorAll('[data-mt-add-form-wrap]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    var addBtn = wrap.querySelector('[data-mt-add]');
    var errorWrap = wrap.querySelector('[data-mt-error-wrap]');
    var errorText = wrap.querySelector('[data-mt-error-text]');
    if (!form || !addBtn) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (addBtn.getAttribute('aria-disabled') === 'true') return;

      if (errorWrap) errorWrap.hidden = true;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('loading');
      var spinner = addBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      var formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            var msg = data.description || data.message || 'No se pudo añadir al carrito.';
            if (errorText) errorText.textContent = msg;
            if (errorWrap) errorWrap.hidden = false;
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
          } else {
            window.location = window.location.pathname.replace(/\/?$/, '') === '/cart' ? window.location.href : '/cart';
          }
        })
        .catch(function () {
          if (errorText) errorText.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
          if (errorWrap) errorWrap.hidden = false;
        })
        .finally(function () {
          addBtn.removeAttribute('aria-disabled');
          addBtn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    });
  });
}
